var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStableDiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stable_diary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.65,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stable_diary"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.35,15.58V584.45A15.57,15.57,0,0,1,532.79,600H50.34V1.13A1.11,1.11,0,0,1,51.45,0H532.79A15.56,15.56,0,0,1,548.35,15.58Z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.08,
    y: 0.02,
    width: 79.95,
    height: 599.64,
    fill: "#00a0df",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.27 157 427.58 109.25 484.9 157 484.9 -0.22 370.27 -0.22 370.27 157",
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.58,434.35a221.44,221.44,0,0,0,30-41.48A222,222,0,0,0,230,334.67a70.19,70.19,0,0,1-29.38,6.92c6.25-17.13,20.27-47.78,50.7-73.76a171.07,171.07,0,0,1,39.76-25.35,74,74,0,0,1-21.32-5.19,141.6,141.6,0,0,1,65.69-15,139,139,0,0,1,41.35,7.18,48.4,48.4,0,0,1,11.08-20.43,49.37,49.37,0,0,1,27.66-15c-4.56,10.23-9,24.82-5.18,40.33a40.43,40.43,0,0,0,3.36,8.85,43.21,43.21,0,0,0,13,14.85c19.91,15.08,18.74,58.2,44.3,87.3,2.2,2.51,8.42,9.27,9.92,19.37.4,2.7,1.64,11.06-3.22,18.29-7.1,10.57-23.9,14-33.42,8.07A52.57,52.57,0,0,1,433,382a46.64,46.64,0,0,1-7.6-11.46c-8.31-16.31-36.29-16-48.4-31.26-5.26-6.6-9.39-18.45-3.46-41.49-6.55,8.18-13.63,20-11.53,32.85.88,5.35,4.12,12.35,4.12,12.35a53.71,53.71,0,0,0-10.45,23.37c-4.37,25.9,15.51,43.79,25.92,68,7.72,17.94,12.84,45.18,1.16,85.86-34.15-8-83.87-25.68-126.77-67.42a246.2,246.2,0,0,1-21.32-23.62,109.43,109.43,0,0,1-57,5.18Z",
    fill: "#00a0df"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableDiary);
export default __webpack_public_path__ + "static/media/stable_diary.08517d4b223fdc32886868fe9d345671.svg";
export { ForwardRef as ReactComponent };